import getOnboardingViewData from './onboarding_view_data'
import getOnboardingLoadedAssets from './onboarding_loaded_assets'
import getStepData from './onboarding_step_data'
import getGradesData from './onboarding_grades_data'
import getSubjectsData from './onboarding_subjects_data'
import getInterestsData from './onboarding_interests_data'
import getTechnologyData from './onboarding_technology_data'
import getAddLessonsData from './onboarding_add_lessons_data'
import getMetricsSelector from './onboarding_metrics_selector'

export default {
	getOnboardingViewData,
	getOnboardingLoadedAssets,
	getStepData,
	getGradesData,
	getSubjectsData,
	getInterestsData,
	getTechnologyData,
	getMetricsSelector,
	getAddLessonsData,
}
